import { useSelector } from "react-redux";

export function useProfileState() {
  return useSelector((state) => state.profile);
}
